'use client';

import { c as _c } from "react/compiler-runtime";
import { LDProvider } from 'launchdarkly-react-client-sdk';
import { type PropsWithChildren } from 'react';
import { flagsContext } from '@/contexts/flagsContext';
import { useEnvironment } from './useEnvironment';
import { useUser } from './useUser';
export const LaunchDarklyProvider = props => {
  const $ = _c(27);
  const {
    isDev,
    isDemo,
    isTest,
    launchDarklyClientId
  } = useEnvironment();
  const {
    currentProjectId,
    user
  } = useUser();
  if (!currentProjectId) {
    return props.children;
  }
  if (isDemo || isDev || isTest) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = {
        view: true,
        trend: true,
        export: true,
        audit: false
      };
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    let t1;
    if ($[1] !== isDev) {
      t1 = {
        AllowAccountLevelSamlWhenOrgAttached: false,
        NonCognitoEonAccounts: false,
        SkipOnboarding: false,
        dlsgFrontend: false,
        LlgFrontend: false,
        NewFilterBar: isDev,
        enableHourlyBackup: false,
        AzureSqlVirtualMachineSupport: true,
        ownCustomerOnboardingEnabled: false,
        byovEnabled: true,
        hourlyDlsgPolicyEnabled: false,
        OnboardTenantAgainEnabled: true,
        GcpRestoreOrgAndFolderSupport: true,
        SecurityFindings: true,
        ClassificationPoliciesEnabled: true,
        Ec2HighFrequencyExcludePlatformEncryption: true,
        EnableGDSGPage: isDev,
        EnableGdsgNotifications: false,
        StorageGatewayCostExplorer: false,
        EnableGdsgObjectBrowser: isDev,
        EnableGdsgObjectActions: isDev,
        EnableGdsgInventoryReports: false,
        SapHanaPitrSupport: true,
        MongoAtlasSupport: true,
        MongoAtlasAdvancedRestoreEnabled: isDev,
        ExploreFilesForDatabaseVms: true,
        RdsRestoreWithoutEncryptionEnabled: false,
        RecordRestoreResultsEnabled: true,
        GcpVmHighFrequencyBackupEnabled: true,
        BypassSourceAccountRequirement: false,
        RdsHighFrequencyBackupEnabled: true,
        EnableAzureVaultNetworkIsolation: false,
        EnableCrossCloudDbBackup: true,
        EnableCrossCloudDbBackupToAzureVault: true,
        EnableCrossCloudDynamoKeyspacesBackup: true,
        AzureSnapshotsDiscoverySupport: true,
        AwsSelectiveOnboarding: true,
        SkipOrgUnitInvokeDiscovery: true,
        AzureFilesSupport: true,
        AwsRdsNativeBackupSupport: true,
        AzureMultipleAppRegistrations: false,
        AzureCustomPermissionsModel: false,
        GoogleWorkspaceSupport: true,
        GwsInPlaceRestoreOnly: false,
        GwsRestoreToTargetMailbox: true,
        GwsRestoreToTargetDrive: true,
        GwsRestoreWholeMailbox: true,
        Microsoft365Support: true,
        Microsoft365RestoreSupport: true,
        EnableMrapForByov: true,
        BigQueryNativeRestoreEnabled: true,
        EnableBigQueryNativePolicy: true,
        GcpProjectLabelTagFilterEnabled: true,
        CancelBackupJobEnabled: true,
        BigQueryRestoreOverwriteEnabled: true,
        SensitivityAnnotations: true,
        EnableNetworkClassification: true,
        RestoreObfuscationEnabled: false,
        RdsRestorePreserveOriginalMemberNames: false,
        AwsKeyspacesSupport: true,
        CassandraSupport: true,
        DataPlatformConsoleEnabled: false,
        RdsCdcUiEnabled: true,
        AiAgents: isDev,
        ZeroEtlUiEnabled: true,
        ZeroEtlUiJobsTabEnabled: true,
        LakehouseEnabled: false,
        lakehouseZeroEtlUiEnabled: true,
        ZeroEtlDynamoDbEnabled: false,
        ZeroEtlMongoDbEnabled: true,
        LakehouseDataQualityUiEnabled: true,
        ZeroEtlMultiResourcePolicies: false,
        DataKnowledgeGraphEnabled: false,
        AgenticDataLayerEnabled: false,
        StreamlakeLakehouseScreens: true,
        EnableExportAccessDeniedItems: true,
        InventoryIssuesColumn: false,
        RestoreTemplates: true,
        BulkRestore: true,
        ThreatHunting: true,
        RemediationOrchestration: true,
        EnableInventoryEntitiesFilter: true,
        SaasInventoryDefaultLanding: false,
        BackupComplianceJson: t0,
        EnableInstantVolumeRestore: true,
        UseTargetVpcForRestoreServer: true,
        UseTargetVpcForFileRestoreServer: true,
        ClassificationOnlyCostExplorer: true
      };
      $[1] = isDev;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {};
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t1) {
      t3 = {
        flags: t1,
        flagKeyMap: t2,
        ldClient: undefined
      };
      $[4] = t1;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== props.children || $[7] !== t3) {
      t4 = <flagsContext.Provider value={t3}>{props.children}</flagsContext.Provider>;
      $[6] = props.children;
      $[7] = t3;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  if (!launchDarklyClientId || !user?.eonAccount) {
    return props.children;
  }
  let t0;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      reactContext: flagsContext,
      useCamelCaseFlagKeys: false
    };
    $[9] = t0;
  } else {
    t0 = $[9];
  }
  let t1;
  if ($[10] !== currentProjectId || $[11] !== user.eonAccount.domain || $[12] !== user.eonAccount.name) {
    t1 = {
      key: currentProjectId,
      name: user.eonAccount.name,
      domain: user.eonAccount.domain
    };
    $[10] = currentProjectId;
    $[11] = user.eonAccount.domain;
    $[12] = user.eonAccount.name;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  let t2;
  if ($[14] !== currentProjectId || $[15] !== user.eonAccount.domain || $[16] !== user.eonAccount.id || $[17] !== user.eonAccount.name) {
    t2 = {
      key: user.eonAccount.id,
      name: user.eonAccount.name,
      domain: user.eonAccount.domain,
      projectId: currentProjectId
    };
    $[14] = currentProjectId;
    $[15] = user.eonAccount.domain;
    $[16] = user.eonAccount.id;
    $[17] = user.eonAccount.name;
    $[18] = t2;
  } else {
    t2 = $[18];
  }
  let t3;
  if ($[19] !== t1 || $[20] !== t2) {
    t3 = {
      kind: "multi",
      user: t1,
      organization: t2
    };
    $[19] = t1;
    $[20] = t2;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  let t4;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      streaming: false
    };
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  let t5;
  if ($[23] !== launchDarklyClientId || $[24] !== props.children || $[25] !== t3) {
    t5 = <LDProvider reactOptions={t0} clientSideID={launchDarklyClientId} timeout={2} context={t3} options={t4}>{props.children}</LDProvider>;
    $[23] = launchDarklyClientId;
    $[24] = props.children;
    $[25] = t3;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  return t5;
};